import { ActivityTaskEditCommandForm } from './forms/ActivityTaskEditCommandForm';
import { hasActivityTaskId } from '@ayocore/activity/common/types/activity-command-context';
import { registerActivityChatCommand } from '@ayocore/activity/client/extensions';

/**
 * Surface `task_edit` — редактирование задачи в `ActivityContextView`.
 */
export const taskEditActivityChatCommand = registerActivityChatCommand({
  id: 'task_edit',
  trigger: 'task-edit',
  label: 'Редактировать задачу',
  description: 'Изменить задачу в контексте чата',
  isAvailable: context => context.source === 'pin' && hasActivityTaskId(context.payload),
  FormComponent: ActivityTaskEditCommandForm,
});
